module.exports = __webpack_public_path__ + "static/media/xpa.f2c7a064.svg";